shared.scrollModule = {
    // Funkcia na zaskrolovanie na povodnu uroven po reloade stranky
    scrollReload: function(pageID, action) {
        try {
            if (pageID) {
                var part = "";
                var partSrollHeight = false;
                switch (pageID) {
                    case "sportsBookEventsFavorites":
                    case "sportsBookEvents":
                        part = ".content-table";
                        partSrollHeight = ".content-table #events";
                        break;
                    case "resultsEventDetail":
                    case "sportsBookEventDetail":
                        part = "#event .chances";
                        break;
                    case "combinationList":
                        part = "#combinationList .ui-controlgroup-controls";
                        break;
                    case "freebetList":
                        part = "#freebetList .ui-controlgroup-controls";
                        break;
                    case "bonificationList":
                        part = "#bonificationList .ui-controlgroup-controls";
                        break;
                }
                if (part) {
                    if (!action || action == "clear") {
                        stored.scroll[pageID] = 0;
                        if (partSrollHeight) {
                            stored.scroll[pageID + "-scrollHeight"] = 0;
                        }
                    } else if (action == "save") {
                        stored.scroll[pageID] = Number($(part).scrollTop());
                        if (partSrollHeight) {
                            stored.scroll[pageID + "-scrollHeight"] = $(partSrollHeight).height();
                        }
                    } else if (action == "reload" && typeof stored.scroll[pageID] === "number") {
                        var lastHeight = 0;
                        var actualHeight = 0;
                        if (partSrollHeight) {
                            lastHeight = stored.scroll[pageID + "-scrollHeight"];
                            actualHeight = $(partSrollHeight).height();
                        }
                        if (lastHeight && pageID === "sportsBookEvents" && stored.scroll[pageID]) {
                            $(part).scrollTop(stored.scroll[pageID] + (actualHeight - lastHeight));
                        } else {
                            $(part).scrollTop(stored.scroll[pageID]);
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na obsluhu buttonov na skrolovanie
    scrollButtons: function(part, height, page) {
        try {
            switch (part) {
                case "offer":
                    shared.scrollModule.checkScrollButtons(".content-offer", "#sportsBook", "#offerBottom .arrows", height);
                    if (offer.page != "popularLeagues" && !profile.VictoryMachine && !stored.popularLeaguesHandler) {
                        shared.scrollModule.scrollOnTapAndHold(null, "content-offer");
                        stored.popularLeaguesHandler = true;
                    }
                    break;
                case "offerVG":
                    shared.scrollModule.checkScrollButtons(".content-offer", "#sportsBookVG", "#offerBottom .arrows", height);
                    if (!profile.VictoryMachine) {
                        shared.scrollModule.scrollOnTapAndHold(null, "content-offer");
                    }
                    break;
                case "offerLG":
                    shared.scrollModule.checkScrollButtons(".content-offer", "#sportsBookLG", "#offerBottom .arrows", height);
                    shared.scrollModule.scrollOnTapAndHold(null, "content-offer");
                    break;
                case "table":
                    shared.scrollModule.checkScrollButtons(".content-table", "#events", "#tableBottom .arrows", height);
                    shared.scrollModule.scrollOnTapAndHold(null, "content-table");
                    break;
                case "event":
                    shared.scrollModule.checkScrollButtons("#event .chances", "#event .chances", "#event .arrows", height);
                    shared.scrollModule.scrollOnTapAndHold("event", "chances");
                    break;
                case "event-stats":
                    shared.scrollModule.checkScrollButtons("#event #betRadarStatsScrollable", "#event #betRadarStatsScrollable", "#event .arrows", height);
                    break;
                case "combi-options":
                    shared.scrollModule.scrollOnTapAndHold("combinationList", "ui-controlgroup-controls");
                    break;
                case "combi-list":
                    shared.scrollModule.scrollOnTapAndHold("combiList", "rows");
                    break;
                case "terms-page":
                    shared.scrollModule.checkScrollButtons("#termsContent", "#paragraph" + page, "#doxxbetTerms .arrows", height);
                    break;
                case "ticket-status-odds":
                    shared.scrollModule.checkScrollButtons("#ticketStatus #oddsContainer", "#ticketStatus #statusOdds", "#ticketStatus .arrows", height);
                    break;
                case "ticket-status-combi":
                    shared.scrollModule.checkScrollButtons("#ticketStatus .status-combi-table", "#ticketStatus .status-combi-table table", "#ticketStatus .arrows-combi", height);
                    break;
                case "bonuses-freebets":
                    shared.scrollModule.checkScrollButtons("#bonusesContent .settings-content", "#bonusesContent #bonusesContentPromocode", "#bonusesContent #bonusesFreebetScrollButtons", height);
                    $("#bonusesFreebetScrollButtons").trigger("create");
                    break;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na overenie zobrazenia buttonov na skrolovanie
    checkScrollButtons: function(parent, child, arrowElement, height, retryCount) {
        try {
            if (!$(arrowElement).length) return true;

            var retries = Number(retryCount) || 0;
            var maxRetries = 10;
            var parentEl = $(parent);
            var childEl = $(child);
            var parentHeight = parentEl.height() || 0;
            var childScrollHeight = childEl.prop("scrollHeight") || 0;

            // Pocitaj az ked ma DOM realne rozmery, inak by sme sipky skryli priskoro a rozbije sa hlavicka ponuky a sipky vpravo v riadkoch
            if (!parentEl.length || !childEl.length || !parentEl.is(":visible") || !childEl.is(":visible") || parentHeight <= 0 || childScrollHeight <= 0) {                
                if (retries < maxRetries) {
                    requestAnimationFrame(function () {
                        shared.scrollModule.checkScrollButtons(parent, child, arrowElement, height, retries + 1);
                    });
                }
                // Ak sa layout nestihol pripravit, nemenime stav sipok a pockame na dalsi trigger.
                return true;
            }

            if (height) {
                if (childScrollHeight > height) {
                    $(arrowElement).show();
                } else {
                    $(arrowElement).hide();
                }
            } else {
                if (childScrollHeight > parentHeight) {
                    $(arrowElement).show();
                    if (parent == ".content-table") $("#section").addClass("scroll-offer");
                } else {
                    $(arrowElement).hide();
                    if (parent == ".content-table") {
                        setTimeout(function () {
                            $("#section").removeClass("scroll-offer");
                        }, 0);
                    }
                }
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecujuca skrolovanie
    scrollPage: function(part, y, speed) {
        try {
            setTimeout(function () {
                if (part === "event" && stored.statsAreShown) part = "event-stats";
                if (part === "offer" && offer.sportID === offer.vgID) {
                    if (offer.page === "virtualGames") {
                        part = "offer-vg";
                    } else if (offer.page === "lotteryGames") {
                        part = "offer-lg";
                    }
                }
                if (part === "ticket" && ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                    if ($("#myTicketsFilterCollapsible").hasClass("ui-collapsible-collapsed")) {
                        part = "my-tickets";
                    } else {
                        $("#myTicketsFilterCollapsible").trigger("collapse");
                        return false;
                    }
                }
                switch (part) {
                    case "offer":
                        shared.scrollModule.checkScroll(".content-offer", "#sportsBook", y, speed);
                        break;
                    case "offer-vg":
                        shared.scrollModule.checkScroll(".content-offer", "#sportsBookVG", y, speed);
                        break;
                    case "offer-lg":
                        shared.scrollModule.checkScroll(".content-offer", "#sportsBookLG", y, speed);
                        break;
                    case "table":
                        shared.scrollModule.checkScroll(".content-table", "#events", y, speed);
                        break;
                    case "event":
                        shared.scrollModule.checkScroll(".chances", "", y, speed);
                        break;
                    case "event-stats":
                        shared.scrollModule.checkScroll("#betRadarStatsScrollable", "", y, speed);
                        break;
                    case "ticket":
                        shared.scrollModule.checkScroll("#ticket", "#ticketList", y, speed);
                        break;
                    case "my-tickets":
                        shared.scrollModule.checkScroll("#myTicketsList", "#myTicketsList", y, speed);
                        break;
                    case "status":
                        shared.scrollModule.checkScroll("#oddsContainer", "", y, speed);
                        break;
                    case "status-combinations":
                        shared.scrollModule.checkScroll(".status-combi-table", "", y, speed);
                        break;
                    case "club":
                        shared.scrollModule.checkScroll("#clubContent", "#clubContent div:not(:hidden)", y, speed);
                        break;
                    case "terms":
                        shared.scrollModule.checkScroll("#termsContent", "#termsContent div:not(:hidden)", y, speed);
                        break;
                    case "freebets-table":
                        shared.scrollModule.checkScroll("#bonusesContentPromocode", "#freebetsTableWrapper #freebetsTable", y, speed);
                        break;
                    case "jackpots":
                        shared.scrollModule.checkScroll("#tableJackpot", "#tableJackpot #jackpotsWrapper", y, speed, true);
                        break;
                    case "quickbet-rules":
                        shared.scrollModule.checkScroll("#quickBetRulesContent", "", y, speed);
                        break;
                    default:
                        $("body").queue();
                        $("body").animate({scrollTop: 0}, "fast");
                        $("body").dequeue();
                        break;
                }
            }, 0);
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
        // Poslanie scroll eventu na tlacitko do GA4 + kde user klikol
        try {
            if (arguments?.callee.caller) {
                if (part && arguments.callee.caller?.name == 'onmousedown') {
                    gtag('event','scroll_click', {
                        'screen_name': offer.page,
                        'screen_part': part
                    });
                }
            }
        } catch (error) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments) + "Error: " + error);
            return false;
        }
    },

    // Kontrola hranic pri skrolovani
    checkScroll: function(part, partH, y, speed, horizontal) {
        try {
            // Aktualna suradnica
            if (horizontal) {
                x = $(part).scrollLeft();
            } else {
                x = $(part).scrollTop();
            }

            // Hranica skorolovania nahor
            if (y == "top" || y == "left" || x + y < 0) {
                x = 0;
            } else {
                // Zistenie spodnej hranice
                var h; // Spodna hranica
                if (partH) {
                    h = (horizontal? $(partH)[0].scrollWidth: $(partH)[0].scrollHeight);
                    // Virtualne hry maju upravenu spodnu hranicu
                } else {
                    $(partH).each(function () {
                        h += $(partH).children().height();
                    });
                }
                // Hranica skrolovania nadol (viem urcit vysku priamo)
                if (partH && x + y > h) {
                    x = h;
                }
                // Skrolovanie
                else {
                    x += y;
                }
            }
            // Posunutie na suradnicu X
            if (!speed) {
                horizontal? $(part).scrollLeft(x): $(part).scrollTop(x);
            } else {
                $(part).queue();
                $(part).animate((horizontal? {scrollLeft: x}: {scrollTop: x}), speed);
                $(part).dequeue();
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecujuca scroll podrzanim a posunutim prsta po elemente (plati pre SB ktorych obrazovky tuto funkcionalitu nepodporuju nativne)
    scrollOnTapAndHold: function(scrollablePartId, scrollablePartClass) {
        try {
            modal.hideTooltip();
            var x = 0;
            stored.actionsHandling.scrolledByTapAndHold = false;
            stored.actionsHandling.downTrigger = false;
            stored.actionsHandling.scrollingElement = null;

            if (scrollablePartId) stored.actionsHandling.scrollingElement = document.getElementById(scrollablePartId);
            else stored.actionsHandling.scrollingElement = document;
        
            if (scrollablePartClass) stored.actionsHandling.scrollingElement = stored.actionsHandling.scrollingElement.getElementsByClassName(scrollablePartClass)[0];
            if (stored.actionsHandling.scrollingElement) {
                stored.actionsHandling.scrollingElement.addEventListener('mousedown', function (e) {
                    stored.actionsHandling.downTrigger = true;
                    stored.actionsHandling.scrolledByTapAndHold = false;
                    stored.actionsHandling.scrollTop = this.scrollTop;
                    x = e.clientY;
                    e.preventDefault();
                    stored.actionsHandling.tempClickedElement = e.target.closest(".SB-root");
                });
                stored.actionsHandling.scrollingElement.addEventListener('mouseup', function (e) {
                    stored.actionsHandling.downTrigger = false;
                    if (e.currentTarget.className == "content-offer" && offer.page == "popularLeagues" && !stored.actionsHandling.scrolledByTapAndHold) {
                        stored.actionsHandling.scrolledByTapAndHold = false;
                        $(stored.actionsHandling.tempClickedElement).click();
                        e.stopImmediatePropagation();
                        e.preventDefault();
                    }
                });
                stored.actionsHandling.scrollingElement.addEventListener('mousemove', function (e) {
                    if (stored.actionsHandling.downTrigger) {
                        this.scrollTop = stored.actionsHandling.scrollTop + x - e.clientY;
                        stored.actionsHandling.scrolledByTapAndHold = true;
                        if (offer.page == "popularLeagues") return;
                    } else {
                        stored.actionsHandling.scrolledByTapAndHold = false;
                    }
                });
                stored.actionsHandling.scrollingElement.addEventListener('mouseleave', function () {
                    stored.actionsHandling.downTrigger = false;
                    stored.actionsHandling.scrolledByTapAndHold = false;
                });

                // Zabranenie zaskrtnutiu checkboxu vo vybere kombinacii
                if (scrollablePartId && scrollablePartId === "combiList") {
                    $('#combiButtons').bindFirst('click', function (e) {
                        if (stored.actionsHandling.scrolledByTapAndHold) {
                            e.stopImmediatePropagation();
                            stored.actionsHandling.scrolledByTapAndHold = false;
                            return false;
                        }
                    });
                }

                // Scroll pre offer
                if (scrollablePartClass && scrollablePartClass == "content-offer" && offer.page != "popularLeagues") {
                    $('.SB-root, .SB-level-a, .SB-level-b').bindFirst('expand', function (e) {
                        if (stored.actionsHandling.scrolledByTapAndHold) {
                            e.stopImmediatePropagation();
                            stored.actionsHandling.scrolledByTapAndHold = false;
                        }
                    });
                    $('.SB-level-root, .SB-level-a, .SB-level-b').bindFirst('collapse', function (e) {
                        if (stored.actionsHandling.scrolledByTapAndHold) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            stored.actionsHandling.scrolledByTapAndHold = false;
                        }
                    });
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error(e);
        }
    }
};
